import {PropertyFilterProperty} from "@amzn/awsui-collection-hooks";
import {CollectionPreferences, PropertyFilterProps, TableProps} from "@amzn/awsui-components-react";
import React from "react";
import {PROPERTY_FILTERING_I18N_LABELS} from "@common/table";
import FormField from "@amzn/awsui-components-react/polaris/form-field";
import RadioGroup from "@amzn/awsui-components-react/polaris/radio-group";
import {
  InventoryReceiptDetailLink
} from "@modules/inbound/inventoryReceiveNotification/table/inventoryReceipt/InventoryReceiptDetailLink";

export const LOADING_TEXT = "Loading Inventory Receipts...";
export const TRACK_BY_COLUMN_NAME = "mcnBatchId";

export const PROPERTY_FILTERING_LABELS: PropertyFilterProps.I18nStrings = {
  ...PROPERTY_FILTERING_I18N_LABELS,
  filteringPlaceholder: "Filter inventory receipts by property or value"
};

export const CUSTOM_PREFERENCE_OPTIONS = [
  {value: "table", label: "Table"}
];

export const DEFAULT_PREFERENCES = {
  pageSize: 25,
  visibleContent: [
    "purchaseOrderId",
    "createdAt",
    "mcnBatchId",
    "receiveType",
    "status",
    "failureReason"
  ],
  wraplines: false,
  custom: CUSTOM_PREFERENCE_OPTIONS[0].value
};

export const FILTERING_PROPERTIES: PropertyFilterProperty[] = [
  {
    propertyLabel: "Purchase Order Id",
    key: "purchaseOrderId",
    groupValuesLabel: "Purchase Order ID values",
    operators: [":", "!:", "=", "!="]
  },
  {
    propertyLabel: "Request Date",
    key: "createdAt",
    groupValuesLabel: "Request Date values",
    operators: [":", "!:", "=", "!="]
  },
  {
    propertyLabel: "Mcn",
    key: "mcn",
    groupValuesLabel: "Mcn values",
    operators: [":", "!:", "=", "!="]
  },
  {
    propertyLabel: "BatchId",
    key: "batchId",
    groupValuesLabel: "BatchId values",
    operators: [":", "!:", "=", "!="]
  },
  {
    propertyLabel: "Receive Type",
    key: "receiveType",
    groupValuesLabel: "Receive Type values",
    operators: [":", "!:", "=", "!="]
  },
  {
    propertyLabel: "Status",
    key: "receiveStatus",
    groupValuesLabel: "Receive status values",
    operators: [":", "!:", "=", "!="]
  },
  {
    propertyLabel: "Failure Reason",
    key: "failureReason",
    groupValuesLabel: "Failure Reason values",
    operators: [":", "!:", "=", "!="]
  }
];

export const COLUMN_DEFINITIONS: TableProps.ColumnDefinition<any>[] = [
  {
    id: "mcnBatchId",
    header: "MCN - BatchId",
    cell: (item) => (
      <InventoryReceiptDetailLink
        siteName={item.siteName}
        mcnBatchId={`${item.mcn}-${item.batchId}`}
      />
    ),
    sortingField: "mcn",
    width: 380,
    minWidth: 370
  },
  {
    id: "purchaseOrderId",
    header: "Purchase Order ID",
    cell: (item) => item.purchaseOrderId,
    sortingField: "purchaseOrderId",
    width: 190,
    minWidth: 185
  },
  {
    id: "receiveType",
    header: "Receive Type",
    cell: (item) => item.receiveType,
    sortingField: "receiveType",
    width: 190,
    minWidth: 185
  },
  {
    id: "createdAt",
    header: "Request Date",
    cell: (item) => item.createdAt,
    sortingField: "createdAt",
    width: 190,
    minWidth: 185
  },
  {
    id: "status",
    header: "Status",
    cell: (item) => item.receiveStatus,
    sortingField: "receiveStatus",
    width: 130,
    minWidth: 125
  },
  {
    id: "failureReason",
    header: "Failure Reason",
    cell: (item) => item.failureReason,
    sortingField: "failureReason",
    width: 200,
    minWidth: 195
  }
];

export const PAGE_SIZE_OPTIONS = [
  {value: 25, label: "25 items"},
  {value: 50, label: "50 items"},
  {value: 100, label: "100 items"}
];

export const VISIBLE_CONTENT_OPTIONS = [
  {
    label: "Main Inventory Receipts properties",
    options: [
      {
        id: "mcnBatchId",
        label: "MCN - BatchId",
        editable: false,
        visible: true
      },
      {
        id: "purchaseOrderId",
        label: "Purchase Order ID",
        editable: false,
        visible: true
      },
      {
        id: "receiveType",
        label: "Receive Type",
        editable: true,
        visible: true
      },
      {
        id: "createdAt",
        label: "Request Date",
        editable: true,
        visible: true
      },
      {
        id: "status",
        label: "Status",
        editable: true,
        visible: true
      },
      {
        id: "failureReason",
        label: "Failure Reason",
        editable: true,
        visible: true
      }
    ]
  }
];

export const Preferences = (
  {
    preferences,
    setPreferences,
    disabled = false,
    pageSizeOptions = PAGE_SIZE_OPTIONS,
    visibleContentOptions = VISIBLE_CONTENT_OPTIONS
  }) => (
  <CollectionPreferences
    title="Preferences"
    confirmLabel="Confirm"
    cancelLabel="Cancel"
    disabled={disabled}
    preferences={preferences}
    onConfirm={({detail}) => setPreferences(detail)}
    pageSizePreference={{
      title: "Page size",
      options: pageSizeOptions
    }}
    wrapLinesPreference={{
      label: "Wrap lines",
      description: "Check to see all the text and wrap the lines"
    }}
    visibleContentPreference={{
      title: "Select visible columns",
      options: visibleContentOptions
    }}
    customPreference={(value, setValue) => (
      <FormField stretch={true} label="View as">
        <RadioGroup
          value={value}
          onChange={({detail}) => setValue(detail.value)}
          items={CUSTOM_PREFERENCE_OPTIONS}
        />
      </FormField>
    )}
  />
);

